<template>
    <div>
        <ActivityLogsTable
            :activity-logs="activityLogs"
            :activity-log-subjects="activityLogSubjects"
            :filters="filters"
            :user-list-view="userListView"
            @changePage="changePage"
            @resetFilters="resetFilters"
        />
        <DFabs>
            <s-s-o-fab
                :customer="customer"
                @open-modal="showCreateCloudpitCustomerModal = true"
                @close-modal="showCreateCloudpitCustomerModal = false"
            />
        </DFabs>
        <CreateCloudPitCustomerModal
            :customer="customer"
            :show-modal="showCreateCloudpitCustomerModal"
            @close-modal="showCreateCloudpitCustomerModal = false"
        />
    </div>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'

import ActivityLogsTable from '~@/Components/Common/ActivityLogs/ActivityLogsTable'
import SSOFab from '~@/Components/Customers/SSOFab'
import CreateCloudPitCustomerModal from '~@/Components/Customers/CreateCloudPitCustomerModal'

export default {
    name: 'CustomerActivityLogsIndex',
    components: {
        SSOFab,
        CreateCloudPitCustomerModal,
        ActivityLogsTable
    },
    layout: [App, CustomerBase],
    props: {
        activityLogs: {
            type: Object,
            default: () => { return {} }
        },
        activityLogSubjects: {
            type: Array,
            default: () => { return [] }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        },
        filters: {
            type: Object,
            default: () => { return {} }
        },
        userListView: {
            type: Array,
            default: () => {
                return []
            }
        },
    },
    data () {
        return {
            showCreateCloudpitCustomerModal: false
        }
    },
    methods: {
        // `only` keeps paging and filtering off the expensive props, which the
        // controller wraps in closures so they are never even resolved. `flash` has
        // to stay in the list: App.vue renders flash.errorMessages, so dropping it
        // would make a rejected filter look like a button that does nothing.
        changePage (page, filters, saveFilters = false) {
            const queryParameters = Object.fromEntries(Object.entries(filters).filter(([_, v]) => v))

            if (page !== 1) {
                queryParameters.page = page
            }

            // Sent as 1, not true: Laravel's `boolean` rule is a strict in_array
            // against [true, false, 0, 1, '0', '1'], and Inertia serializes the
            // data object with qs.stringify, which renders true as the string
            // "true" -- rejected. (Ziggy's own encoder coerces booleans to 1,
            // which is why passing these as route params happened to work.)
            if (saveFilters === true) {
                queryParameters.save_filters = 1
            }

            this.$inertia.get(
                this.$route('customers.customers.activity-logs.index', { customer: this.customer.id }),
                queryParameters,
                { only: ['activityLogs', 'filters', 'flash'] }
            )
        },
        resetFilters () {
            this.$inertia.get(
                this.$route('customers.customers.activity-logs.index', { customer: this.customer.id }),
                { save_filters: 1, default_filters: 1 },
                { only: ['activityLogs', 'filters', 'flash'] }
            )
        }
    }
}
</script>
